import React from 'react';
import { AdminConsole } from '@components/AdminConsole';

export const AdminConsolePage: React.FC = () =>
{
  return <AdminConsole />;
};
